import React from 'react'
import OpenAILogo from '../../../assets/images/logos/openai.svg'

type Props = {
  alt?: string
}

export default function OpenAIAdsLogo({ alt = 'OpenAI Ads logo' }: Props) {
  return (
    <div className="tw-flex tw-h-full tw-items-center tw-gap-1.5">
      <img
        src={OpenAILogo}
        className="tw-h-full tw-w-auto tw-max-h-full tw-shrink-0"
        alt={alt}
      />
      <span className="tw-shrink-0 tw-text-sm tw-font-semibold tw-text-slate-600">Ads</span>
    </div>
  )
}
